import { render, staticRenderFns } from "./TabContentRating.vue?vue&type=template&id=32f0d92a&scoped=true"
import script from "./TabContentRating.vue?vue&type=script&lang=js"
export * from "./TabContentRating.vue?vue&type=script&lang=js"
import style0 from "./TabContentRating.vue?vue&type=style&index=0&id=32f0d92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0d92a",
  null
  
)

export default component.exports